import React, { Component } from 'react';
import PropTypes from 'prop-types';
import WebsiteVisitationTable from './WebsiteVisitationTable';

import PCIcon from '../../images/pc-icon_246-116-81.png';
import CellTabletIcon from '../../images/cell-tablet-icon_92-164-169.png';
import * as messages from './../../messages/ReportsMessages';
import { MODULE_WEBSITE_VISITATION } from '../../constants';
import QuickReportFootNote from './QuickReportFootNotes';

const ReportDropdown = [
  { key: 'WEBR_7', value: '7 Days' },
  { key: 'WEBR_30', value: '30 Days' },
];

export default class WebsiteVisitation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDropdown: '7 Days',
      selectedDropdownValue: 'WEBR_7',
      nextDropdown: '30 Days',
      combos: [],
      data: this.props.data,
      childData: {},
      showSingleAsterisk: false,
      showDoubleAsterisk: false,
    };
  }

  componentDidMount() {
    this.props.handletitle('Website Visitation by Percentage: 7 Days');
    this.props.runReport(null, null, 'WEBR_7D');
    this.props.handleExportParams(
      undefined,
      this.state.selectedDropdownValue,
      undefined,
    );
    this.props.trackerFn({ subModule: MODULE_WEBSITE_VISITATION });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.reportName === 'WEBR_7D' ||
      nextProps.reportName === 'WEBR_30D'
    ) {
      this.setState({
        childData: nextProps.data,
      });
    } else {
      this.setState(
        {
          data: nextProps.data,
          selectedDropdown:
            nextProps.reportName === 'WEBR_7' ? '7 Days' : '30 Days',
        },
        () => {
          this.props.handleExportParams(
            undefined,
            this.state.selectedDropdownValue,
            undefined,
          );
        },
      );

      if (this.props.reportName !== nextProps.reportName) {
        this.props.handletitle(
          `Website Visitation by Percentage: ${
            nextProps.reportName === 'WEBR_7' ? '7 Days' : '30 Days'
          }`,
        );
      }
    }
  }

  handleDropdownChange = e => {
    this.props.runReport(null, null, e.currentTarget.value);
    this.props.runReport(null, null, `${e.currentTarget.value}D`);
    this.setState(
      {
        selectedDropdownValue: e.currentTarget.value,
        data: {},
        childData: {},
      },
      () => {
        this.props.handleExportParams(
          undefined,
          this.state.selectedDropdownValue,
          undefined,
        );
      },
    );
  };

  updateAsteriskStatus = asterisk => {
    // console.log(" asterik option " +asterisk);
    if (asterisk === '*' && !this.state.showSingleAsterisk) {
      this.setState({ showSingleAsterisk: true });
    } else if (asterisk === '**' && !this.state.showDoubleAsterisk) {
      this.setState({ showDoubleAsterisk: true });
    }
  };

  renderDropdown = () =>
  ReportDropdown.map(({ key, value }) => (
    <option value={key} key={key}>
      {value}
    </option>
  ));

  renderSpinner = () => (
    <div className="text-center" style={{ marginTop: '14%' }}>
      <p>Loading Data</p>
      <div
        className="loader-text"
        style={{ marginBottom: '20px', position: 'relative' }}
      >
        <div className="spinner">
          <div className="bounce1" />
          <div className="bounce2" />
          <div className="bounce3" />
        </div>
      </div>
    </div>
  );

  render() {
    return (
      <div className="quick-report-graph-wrapper">
        <div className="large-12 text-center margin-top-10 margin-bottom-10">
          <div className="quick-report-dropdown display-inline">
            <select
              onChange={this.handleDropdownChange}
              value={this.state.selectedDropdownValue}
            >
              {this.renderDropdown()}
            </select>
          </div>
        </div>
        <div className="column large-12">
          <div className="column medium-6 large-6 padding-left-0 padding-right-10 ">
            <div className="pc-website">
              <img
                src={PCIcon}
                className="website-visitation-cat-icon"
                alt="PC Websites"
              />
              <h4 className="report-chart-title">PC Websites</h4>
            </div>
            {Object.keys(this.state.data).length &&
            Object.keys(this.state.childData).length ? (
              <WebsiteVisitationTable
                data={
                  this.state.data[
                    `PC Website Categories - Last ${
                      this.state.selectedDropdown
                    }`
                  ]
                }
                childData={this.state.childData}
                type={'PC'}
                updateAsteriskStatus={this.updateAsteriskStatus}
              />
            ) : (
              this.renderSpinner()
            )}
          </div>
          <div className="column medium-6 large-6 padding-right-0 padding-left-10 ">
            <div className="pc-website">
              <img
                src={CellTabletIcon}
                className="website-visitation-cat-icon"
                alt="Mobile Websites"
              />
              <h4 className="report-chart-title">Mobile Websites</h4>
            </div>
            {Object.keys(this.state.data).length &&
            Object.keys(this.state.childData).length ? (
              <WebsiteVisitationTable
                data={
                  this.state.data[
                    `Mobile Website Categories - Last ${
                      this.state.selectedDropdown
                    }`
                  ]
                }
                childData={this.state.childData}
                type={'Mobile'}
                updateAsteriskStatus={this.updateAsteriskStatus}
                showDoubleAsterisk={this.state.showDoubleAsterisk}
                showSingleAsterisk={this.state.showSingleAsterisk}
              />
            ) : (
              this.renderSpinner()
            )}
          </div>
        </div>
        <QuickReportFootNote
          studyInfo={this.props.study}
          className="padding-astrick font-12"
          showSingleAsterisk={this.state.showSingleAsterisk}
          showDoubleAsterisk={this.state.showDoubleAsterisk}
        />
      </div>
    );
  }
}

WebsiteVisitation.propTypes = {
  data: PropTypes.shape({}),
  handletitle: PropTypes.func,
  handleExportParams: PropTypes.func,
  runReport: PropTypes.func,
  reportName: PropTypes.string,
  trackerFn: PropTypes.func,
  study: PropTypes.shape({}),
};
